import { useEffect, useState } from "react";
import { AlertTriangle, Bell } from "lucide-react";

function Badge({ days }) {
  if (days < 0) return <span className="px-2 py-1 text-xs rounded bg-red-100 text-red-600">منتهي</span>;
  if (days <= 7) return <span className="px-2 py-1 text-xs rounded bg-orange-100 text-orange-700">عاجل</span>;
  return <span className="px-2 py-1 text-xs rounded bg-yellow-100 text-yellow-700">{days} يوم</span>;
}

export default function AdminRenewals() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(null);

  useEffect(() => {
    fetch("/api/admin/subscriptions-expiring.php")
      .then(r => r.json())
      .then(j => j.ok && setRows(j.data || []))
      .finally(() => setLoading(false));
  }, []);

  const notify = async (subscription_id) => {
    setSending(subscription_id);
    await fetch("/api/admin/notify-renewal.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ subscription_id, channel: "email" })
    });
    setSending(null);
    alert("تم تجهيز التنبيه");
  };

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-extrabold">تنبيهات التجديد</h2>
        <p className="text-sm text-slate-500">اشتراكات قريبة من الانتهاء</p>
      </div>

      <div className="bg-white border rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[900px]">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-4 py-3 text-right">النطاق</th>
              <th className="px-4 py-3 text-right">العميل</th>
              <th className="px-4 py-3 text-center">الخطة</th>
              <th className="px-4 py-3 text-center">المتبقي</th>
              <th className="px-4 py-3 text-center">إجراء</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan="5" className="px-4 py-6 text-center">جاري التحميل…</td></tr>
            )}
            {!loading && rows.length===0 && (
              <tr><td colSpan="5" className="px-4 py-6 text-center">لا توجد تنبيهات</td></tr>
            )}
            {rows.map(r => (
              <tr key={r.subscription_id} className="border-t">
                <td className="px-4 py-3 font-mono">{r.domain}</td>
                <td className="px-4 py-3">{r.client_name}</td>
                <td className="px-4 py-3 text-center">{r.plan}</td>
                <td className="px-4 py-3 text-center"><Badge days={r.days_left} /></td>
                <td className="px-4 py-3 text-center">
                  <button
                    onClick={() => notify(r.subscription_id)}
                    disabled={sending===r.subscription_id}
                    className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-[#4A9FD8] text-white disabled:opacity-50"
                  >
                    <Bell size={16} />
                    {sending===r.subscription_id ? "جارٍ الإرسال…" : "إرسال تنبيه"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
